module.exports = __webpack_public_path__ + "static/media/farastarter-stake.2d2a37a2.png";